import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FormulasOptions } from "@shared/enums/formulas-options";
import { ForOptTarif } from "@shared/enums/foropttarif.enum";
import { OptionalService } from "@shared/enums/optional-service.enum";
import { PackagesLabelType } from "@shared/enums/packages-label-type";
import { PackagesType } from "@shared/enums/packages-type";
import { PackagesTypeId } from "@shared/enums/packages-type-id";
import { PolicyFields } from "@shared/enums/policy-fields.enum";
import {
  getDropdownClass,
  getInputClass,
  getIsEditable,
  getIsVisible,
  getNonEditableInputClass,
  getIsOptionEditable,
} from "@shared/helpers/contract-edition.helper";
import { QualiteOccupant } from "@shared/models/contract-options-state.model";
import { PolicyDetail } from "@shared/models/policy-details";
import { PolicyFieldsVM } from "@shared/models/policy-field-vm.model";
import { DropdownModule } from "primeng/dropdown";

@Component({
  selector: "app-contract-edition-foropttarif-mrh",
  standalone: true,
  imports: [TranslateModule, DropdownModule, FormsModule, CommonModule],
  templateUrl: "./contract-edition-foropttarif-mrh.component.html",
})
export class ContractEditionForOptTarifMrhComponent implements OnInit {
  @Input() policyFieldsVM!: PolicyFieldsVM;
  @Input() policyDetails!: PolicyDetail;
  @Input() policyDetailsCopy!: PolicyDetail;
  @Input() formulaValues!: { id: number; code: string; label: string }[];
  @Input() nombrePieces!: string | undefined;
  @Input() isConfort!: boolean;
  @Input() qualiteOccupant!: string | undefined;
  @Input() hasEndorsementWait4Sign!: boolean;
  @Output() emitIsSchoolInsuranceSelected = new EventEmitter<boolean>();
  @Output() emitBailleurHasChanged = new EventEmitter<boolean>();
  @Output() emitFormulaChange = new EventEmitter<string>();
  @Output() emitPjHasChanged = new EventEmitter<boolean>();
  @Output() emitVanHasChanged = new EventEmitter<boolean>();
  PolicyFields = PolicyFields;
  ForOptTarif = ForOptTarif;
  OptionalService = OptionalService;
  options = FormulasOptions;
  QualiteOccupant = QualiteOccupant;
  defaultValuableObject!: any;
  preventOptionSubscription: boolean = false;
  

  getIsVisible = getIsVisible;
  getIsEditable = getIsEditable;
  getInputClass = getInputClass;
  getDropdownClass = getDropdownClass;
  getNonEditableInputClass = getNonEditableInputClass;
  getIsOptionEditable = getIsOptionEditable;

  valuableObjectOptions = [
    {
      label: this.translate.instant("valuableObjects.rateFiveLabel"),
      value: "5000",
    },
    {
      label: this.translate.instant("valuableObjects.rateTenLabel"),
      value: "10000",
    },
    {
      label: this.translate.instant("valuableObjects.rateTwentyLabel"),
      value: "20000",
    },
  ];

  valuableObjectOptionsInitial = this.valuableObjectOptions;

  capitalImmobilierOptions = [
    { pieces: "1", value: "10000", confortValue: "10000", confortPlusValue: "30000" },
    { pieces: "2", value: "10000", confortValue: "10000", confortPlusValue: "30000" },
    { pieces: "3", value: "15000", confortValue: "15000", confortPlusValue: "40000" },
    { pieces: "4", value: "20000", confortValue: "20000", confortPlusValue: "50000" },
    { pieces: "5", value: "25000", confortValue: "25000", confortPlusValue: "60000" },
    { pieces: "6", value: "30000", confortValue: "30000", confortPlusValue: "70000" },
    { pieces: "7", value: "35000", confortValue: "35000", confortPlusValue: "80000" },
    { pieces: "8", value: "40000", confortValue: "40000", confortPlusValue: "90000" },
    { pieces: "9", value: "45000", confortValue: "45000", confortPlusValue: "100000" },
    { pieces: "10", value: "50000", confortValue: "50000", confortPlusValue: "110000" },
    { pieces: "11", value: "55000", confortValue: "55000", confortPlusValue: "120000" },
    { pieces: "12", value: "60000", confortValue: "60000", confortPlusValue: "130000" },
  ];

  valuableObjectValues = [
    { pieces: "1", value: "2500" },
    { pieces: "2", value: "2500" },
    { pieces: "3", value: "3750" },
    { pieces: "4", value: "5000" },
    { pieces: "5", value: "6250" },
    { pieces: "6", value: "7500" },
    { pieces: "7", value: "8750" },
    { pieces: "8", value: "10000" },
    { pieces: "9", value: "11250" },
    { pieces: "10", value: "12500" },
    { pieces: "11", value: "13750" },
    { pieces: "12", value: "15000" },
  ];

  selectedCapitalMobilier!: { pieces: string; value: string; confortValue: string; confortPlusValue: string };

  yesNoValues: { label: string; value: boolean }[] = [
    { label: "Oui", value: true },
    { label: "Non", value: false },
  ];
  noValuableObject = "Pas d'objet de valeur";

  formulaHasChanged = false;
  valuableObjectHasChanged = false;
  capMobHasChanged = false;
  PJSOLHasChanged = false;
  RCSHasChanged = false;
  bailleurHasChanged = false;
  PjHasChanged = false;
  VanHasChanged = false;

  defaultPjValue = false;
  defaultVanValue = false;

  constructor(private readonly translate: TranslateService) {}

  ngOnInit(): void {
    this.setPolicyInitialValues();
    this.selectedCapitalMobilier =
      this.capitalImmobilierOptions.find(x => x.pieces === this.nombrePieces) || this.capitalImmobilierOptions[0];
  }

  getCapitalMobilier() {
    if (this.policyDetailsCopy.formulasAndOptionsInformations.formulaId === PackagesTypeId.Confort) {
      this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[0].value =
        this.selectedCapitalMobilier.confortValue;
    } else if (this.policyDetailsCopy.formulasAndOptionsInformations.formulaId === PackagesTypeId.ConfortPlus) {
      this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[0].value =
        this.selectedCapitalMobilier.confortPlusValue;
    } else {
      this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[0].value =
        this.selectedCapitalMobilier.value;
    }
    this.onCapMobChange();
    return this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[0].value;
  }

  setPolicyInitialValues() {
    if (
      this.policyDetailsCopy.formulasAndOptionsInformations.formulaName !== PackagesLabelType.Confort &&
      this.policyDetailsCopy.formulasAndOptionsInformations.formulaName !== PackagesLabelType.ConfortPlus
    ) {
      const formula = this.formulaValues?.find(
        x => x.id === this.policyDetailsCopy.formulasAndOptionsInformations.formulaId
      );
      if (formula) {
        this.formulaValues = [{ id: formula.id, code: formula.code, label: formula.label }];
      }
    } else {
      this.formulaValues = [
        { id: 1, code: PackagesType.Confort, label: PackagesLabelType.Confort },
        { id: 2, code: PackagesType.ConfortPlus, label: PackagesLabelType.ConfortPlus },
      ];
    }
    this.policyDetails.formulasAndOptionsInformations.caracteristics[1].value =
      this.policyDetails.formulasAndOptionsInformations.caracteristics[1].value.trim();
    this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[1].value =
      this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[1].value.trim();
    this.defaultValuableObject = this.valuableObjectOptions.find(
      x => x.value === this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[1].value
    );
    if (
      !this.valuableObjectOptions.find(
        x => x.value === this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[1].value
      )
    ) {
      this.valuableObjectOptions = [
        {
          label: this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[1].value + " €",
          value: this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[1].value,
        },
      ];
    }

    this.defaultPjValue =
      this.policyDetailsCopy.formulasAndOptionsInformations.options.find(x => x.type === this.options.PJ)?.isSelected ??
      false;
    this.defaultVanValue =
      this.policyDetailsCopy.formulasAndOptionsInformations.options.find(x => x.type === this.options.VAN)
        ?.isSelected ?? false;
    this.preventOptionSubscription = this.policyDetails.formulasAndOptionsInformations.preventOptionSubscription
  }

  updateRCSHasChanged() {
    this.RCSHasChanged =
      this.policyDetails.formulasAndOptionsInformations.options.find(x => x.type === this.options.RCS)?.isSelected !==
      this.policyDetailsCopy.formulasAndOptionsInformations.options.find(x => x.type === this.options.RCS)?.isSelected;
  }

  updateCapitalMobilier(pieces: string) {
    this.selectedCapitalMobilier =
      this.capitalImmobilierOptions.find(x => x.pieces === pieces) || this.capitalImmobilierOptions[0];
  }

  updateValuableObject(nombrePieces: string) {
    this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[1].value = this.valuableObjectValues.find(
      x => x.pieces === nombrePieces
    )!.value;
    this.onValuableObjectChange();
  }

  updatePjOption() {
    this.PjHasChanged =
      this.policyDetails.formulasAndOptionsInformations.options.find(x => x.type === this.options.PJ)?.isSelected !==
      this.policyDetailsCopy.formulasAndOptionsInformations.options.find(x => x.type === this.options.PJ)?.isSelected;
  }

  updateVanOption() {
    this.VanHasChanged =
      this.policyDetails.formulasAndOptionsInformations.options.find(x => x.type === this.options.VAN)?.isSelected !==
      this.policyDetailsCopy.formulasAndOptionsInformations.options.find(x => x.type === this.options.VAN)?.isSelected;
  }

  updateAttestationBailleur(qualiteOccupant: string) {
    if (qualiteOccupant === QualiteOccupant.Proprietaire) {
      this.policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption = false;
    }
    this.onBailleurHasChanged();
  }

  onFormulaChanged() {
    this.formulaHasChanged =
      this.policyDetails.formulasAndOptionsInformations?.formulaId !==
      this.policyDetailsCopy.formulasAndOptionsInformations?.formulaId;
    if (this.formulaHasChanged && this.policyDetailsCopy.formulasAndOptionsInformations?.formulaId === 2) {
      this.valuableObjectOptions = this.valuableObjectOptionsInitial;
      this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[1].value =
        this.valuableObjectOptions[0].value;
    }

    this.selectedCapitalMobilier =
      this.capitalImmobilierOptions.find(x => x.pieces === this.nombrePieces) || this.capitalImmobilierOptions[0];

    // this.policyDetailsCopy.formulasAndOptionsInformations.valuableItem.isIncluded =
    //   this.policyDetailsCopy.formulasAndOptionsInformations?.formulaId === 2;
    // if (this.policyDetailsCopy.formulasAndOptionsInformations.valuableItem.isIncluded) {
    //   this.valuableObjectOptions = this.valuableObjectOptionsInitial;
    // }

    if (this.policyDetailsCopy.formulasAndOptionsInformations?.formulaId === 1) {
      this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[1].value = "0";
      this.onValuableObjectChange();
    }
    this.emitFormulaChange.emit(this.getCapitalMobilier());
  }

  onValuableObjectChange() {
    this.valuableObjectHasChanged =
      this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[1].value !==
      this.policyDetails.formulasAndOptionsInformations.caracteristics[1].value;
  }

  onCapMobChange() {
    this.capMobHasChanged =
      this.policyDetails.formulasAndOptionsInformations.caracteristics[0].value !==
      this.policyDetailsCopy.formulasAndOptionsInformations.caracteristics[0].value;
  }

  onPJSOLHasChanged() {
    this.PJSOLHasChanged =
      this.policyDetails.formulasAndOptionsInformations.options.find(
        x => x.type === this.options.PJ || x.type === this.options.PJSOL
      )?.isSelected !==
      this.policyDetailsCopy.formulasAndOptionsInformations.options.find(
        x => x.type === this.options.PJ || x.type === this.options.PJSOL
      )?.isSelected;
  }

  onRCSHasChanged() {
    this.RCSHasChanged =
      this.policyDetails.formulasAndOptionsInformations.options.find(x => x.type === this.options.RCS)?.isSelected !==
      this.policyDetailsCopy.formulasAndOptionsInformations.options.find(x => x.type === this.options.RCS)?.isSelected;
    const isSchoolAssuranceSelected = this.policyDetailsCopy.formulasAndOptionsInformations.options.find(
      x => x.type === this.options.RCS
    )?.isSelected;
    this.emitIsSchoolInsuranceSelected.emit(isSchoolAssuranceSelected);
  }

  onBailleurHasChanged() {
    this.bailleurHasChanged =
      this.policyDetails.optionalServicePolicyVm.sendCertificationOption !==
      this.policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption;
    this.emitBailleurHasChanged.emit(this.bailleurHasChanged);
  }

  getBailleurValue() {
    return this.policyDetailsCopy.optionalServicePolicyVm.sendCertificationOption
      ? this.translate.instant("generalOptions.yes")
      : this.translate.instant("generalOptions.no");
  }

  onVANHasChanged() {
    this.VanHasChanged =
      this.policyDetails.formulasAndOptionsInformations.options.find(x => x.type === this.options.VAN)?.isSelected !==
      this.policyDetailsCopy.formulasAndOptionsInformations.options.find(x => x.type === this.options.VAN)?.isSelected;
    const vanSelected = this.policyDetailsCopy.formulasAndOptionsInformations.options.find(
      x => x.type === this.options.VAN
    )?.isSelected;
    this.emitVanHasChanged.emit(vanSelected);
  }

  onPJHasChanged() {
    this.PjHasChanged =
      this.policyDetails.formulasAndOptionsInformations.options.find(x => x.type === this.options.PJ)?.isSelected !==
      this.policyDetailsCopy.formulasAndOptionsInformations.options.find(x => x.type === this.options.PJ)?.isSelected;
    const pjSelected = this.policyDetailsCopy.formulasAndOptionsInformations.options.find(
      x => x.type === this.options.PJ
    )?.isSelected;
    this.emitPjHasChanged.emit(pjSelected);
  }
}
